export const BASE_URL = "https://kosmatic-backend.germanboard.org/api";

export const BASE_URL_IMAGE = "https://kosmatic-backend.germanboard.org";
